import _styled from '@emotion/styled/base';
import { Button } from '../Button/index.js';
import { Flex } from '../Flex/index.js';
import { formElementTextStyles } from '../formElements.js';
import { Text } from '../Text/index.js';
import { Spacing } from '../primitives/spacing.js';
import { mediaQuery } from '../primitives/media-queries.js';
import { getColor } from '../utils/themeUtils.js';
import { Colors } from '../primitives/color.js';
import { Spacer } from '../primitives/Spacer/index.js';

const baseFileUploaderStylesObj = {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  borderRadius: Spacing.scale[1],
  padding: `0 ${Spacing.scale[1.5]}`
};
const EmptyZone = _styled("div", {
  target: "e138wktv13"
})(baseFileUploaderStylesObj, ";height:88px;border:1px dashed ", getColor(Colors.gray[200], Colors.gray[400]), ";");
const DropzoneWrapper = _styled("div", {
  target: "e138wktv12"
})(formElementTextStyles, ";", baseFileUploaderStylesObj, ";height:88px;border:1px dashed ", getColor(Colors.gray[200], Colors.gray[400]), ";", p => p.disabled && `
    cursor: not-allowed;
    background-color: ${getColor(Colors.gray[50], Colors.gray[900])(p)};
    border-color: ${getColor(Colors.gray[100], Colors.gray[800])(p)};
    color: ${getColor(Colors.gray[300], Colors.gray[600])(p)};
  `, " &:hover{", p => !p.disabled && `
    cursor: pointer;
    border-color: ${getColor(Colors.gray[300], Colors.gray[400])(p)};`, ";}", p => p.dropzone && !p.disabled && `
    border-color: ${getColor(Colors.blue[500], Colors.blue[300])(p)};
    background-color: ${getColor(Colors.blue[50], Colors.blue[800])(p)};
  `, " ", p => Boolean(p.error) && `
    border-color: ${getColor(Colors.red[600], Colors.red[400])(p)};
    background-color: ${getColor(Colors.red[50], Colors.red[800])(p)};
  `, " &:focus{", p => `border-color: ${p.error ? Colors.red[600] : getColor(Colors.black, Colors.white)(p)};`, " border-width:2px;padding:0 11px;outline:none;}");
const FileWrapper = _styled("div", {
  target: "e138wktv11"
})(formElementTextStyles, ";", baseFileUploaderStylesObj, ";height:88px;border:1px solid ", getColor(Colors.gray[200], Colors.gray[400]), ";position:relative;", p => !p.readOnly && `
    &:focus {
      ${p => `border-color: ${p.error ? Colors.red[600] : getColor(Colors.black, Colors.white)(p)};`}
      border-width: 2px;
      padding: 0 11px;
      outline: none;
    }
  `, " ", p => Boolean(p.error) && `
    border-color: ${getColor(Colors.red[600], Colors.red[400])(p)};
    background-color: ${getColor(Colors.red[50], Colors.red[800])(p)};
  `, ";");
const FlexWrapper = _styled(Flex, {
  target: "e138wktv10"
})("width:100%;height:100%;align-items:center;justify-content:center;position:relative;>*{padding:0 ", Spacing.scale[0.5], ";}");
const FileUploaderWrapper = _styled(Spacer, {
  target: "e138wktv9"
})("min-width:288px;@media ", mediaQuery.tabletSmUp, "{min-width:370px;}");
const IconButton = _styled(Button.Tertiary, {
  target: "e138wktv8"
})("padding:0;border-radius:", Spacing.scale[7], ";min-width:", Spacing.scale[5], ";height:", Spacing.scale[5], ";@media ", mediaQuery.mobileXsDown, "{width:auto;}");
const AnimatedCircle = _styled("circle", {
  target: "e138wktv7"
})(({
  duration
}) => `transition: all ${duration}ms linear;`, " ", p => p.variation === 'base' && `stroke: ${getColor(Colors.gray[50], Colors.gray[700])(p)};`, " ", p => p.variation === 'loading' && `stroke: ${getColor(Colors.gray[900], Colors.white)(p)};`, " ", p => p.variation === 'success' && `stroke: ${getColor(Colors.green[600], Colors.green[300])(p)};`, ";");
const InnerLoader = _styled("div", {
  target: "e138wktv6"
})({
  name: "1dbtoua",
  styles: "position:absolute;top:0"
} );
const ToggleItem = _styled("div", {
  target: "e138wktv5"
})("position:absolute;top:0;transition:opacity 600ms,transform 600ms;", ({
  isHidden
}) => isHidden && `
    opacity: 0;
    transform: scale(0.7);
  `, ";");
const CircleProgressWrapper = _styled("div", {
  target: "e138wktv4"
})("position:relative;", ({
  size
}) => `
    width: ${size}px; height: ${size}px;

    > div {
      position: 0;
      top: 0;
    }
    > div:first-of-type {
      width: ${size}px; height: ${size}px;
    }

    ${ToggleItem} {
      ${({
  duration
}) => `transition: opacity ${duration}ms, transform ${duration}ms;`}
    }
  `, ";");
const TextDiv = _styled(Text.Body, {
  target: "e138wktv3"
})({
  name: "1d3w5wq",
  styles: "width:100%"
} );
const Underlined = _styled(Text.Body, {
  target: "e138wktv2"
})({
  name: "3xzurr",
  styles: "text-decoration:underline;color:inherit"
} );
const SmallDeviceContent = _styled(Text.Body, {
  target: "e138wktv1"
})("display:none;@media ", mediaQuery.tabletSmDown, "{display:inline-block;}");
const WideDeviceContent = _styled(Text.Body, {
  target: "e138wktv0"
})("@media ", mediaQuery.tabletSmDown, "{display:none;}");

export { AnimatedCircle, CircleProgressWrapper, DropzoneWrapper, EmptyZone, FileUploaderWrapper, FileWrapper, FlexWrapper, IconButton, InnerLoader, SmallDeviceContent, TextDiv, ToggleItem, Underlined, WideDeviceContent };
